module.exports = "pegasus/assets/blocks/header-image-social.png";